//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Pie from "@/components/charts/Pie";
import Bar from "@/components/charts/Bar";
import {annotationValues, Color} from "@/constants";
import {mapGetters} from "vuex";

const _YES_NO = "Yes/No";
const _INPUT = "Input";
const _NOT_SURE = "Not Sure";

export default {
  name: "Drilldown",
  components: {
    Bar,
    Pie,
  },

  props: {
    missionId: {
      type: String
    },
    all: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({
    annotations: [],
    partitions: [],
    datasets: [],
    labels: [],
    colors: [],
    showAll: true,
  }),

  computed: {
    ...mapGetters(["projectId"]),

    partitionsSum() {
      if (this.partitions) {
        return this.partitions.reduce((a, b) => a + b, 0);
      }
      return 0;
    }
  },

  watch: {
    showAll() {
      this.selectReviews();
    },

    annotations(newVal) {
      if (newVal && newVal.length > 0) {
        this._resetAnnotations(newVal);
      }
    },

    datasets(newVal) {
      if (newVal) {
        this.partitions = newVal.map(val => val.data.reduce((a, b) => a + b, 0));
        this.labels = newVal.map(val => this._labelFor(val.label));
        this.colors = newVal.map(val => this._colorFor(val.label));
      }
    },

    projectId() {
      this.fetch();
    }
  },

  mounted() {
    this.$nextTick(function () {
      // Code that will run only after the
      // entire view has been rendered
      this.fetch();
    })
  },

  methods: {
    fetch() {
      this.$refs.fetchMetrics.params = {
        all: this.all,
        missionId: this.missionId || ''
      };
      this.$refs.fetchMetrics
          .get()
          .then(response => {
            if (response && response.aggregations) {
              this.annotations = this._mergeAggregates(response.aggregations);
            }
          })
          .catch(err => console.error(err));
    },

    _resetAnnotations(newVal) {
      this.datasets = this._getDataset(newVal);
    },

    _getDataset(annotations) {
      return annotations.map(val => {
        return {
          label: this._labelFor(val.key),
          data: val.buckets.map(entry => entry.doc_count),
          backgroundColor: this._colorFor(val.key),
          labels: val.buckets.map(entry => entry.key)
        }
      }).sort((a, b) => b.date - a.date);
    },

    selectReviews() {
      this.fetch();
      this.reviewFilter("RESET");
    },

    reviewFilter(kind) {
      let datasets = this._getDataset(this.annotations);
      switch (kind) {
        case annotationValues.CONFIRMED:
          if (this.$refs.confirmedBtn.style["text-decoration"] === "line-through") {
            this.$refs.confirmedBtn.style["text-decoration"] = "none";
            this.datasets = this.datasets.concat(datasets.filter(val => val.label === _YES_NO));
          } else {
            this.$refs.confirmedBtn.style["text-decoration"] = "line-through";
            this.datasets = this.datasets.filter(val => val.label !== _YES_NO);
          }
          break;
        case annotationValues.HAND_INPUT:
          if (this.$refs.inputBtn.style["text-decoration"] === "line-through") {
            this.$refs.inputBtn.style["text-decoration"] = "none";
            this.datasets = this.datasets.filter(val => val.label === _NOT_SURE)
                .concat(datasets.filter(val => val.label === _INPUT))
                .concat(this.datasets.filter(val => val.label === _YES_NO));
          } else {
            this.$refs.inputBtn.style["text-decoration"] = "line-through";
            this.datasets = this.datasets.filter(val => val.label !== _INPUT);
          }
          break;
        case annotationValues.NOT_SURE:
          if (this.$refs.notSureBtn.style["text-decoration"] === "line-through") {
            this.$refs.notSureBtn.style["text-decoration"] = "none";
            this.datasets = datasets.filter(val => val.label === _NOT_SURE).concat(this.datasets);
          } else {
            this.$refs.notSureBtn.style["text-decoration"] = "line-through";
            this.datasets = this.datasets.filter(val => val.label !== _NOT_SURE);
          }
          break;
        case "RESET":
          this.$refs.confirmedBtn.style["text-decoration"] = "none";
          this.$refs.inputBtn.style["text-decoration"] = "none";
          this.$refs.notSureBtn.style["text-decoration"] = "none";
          break;
        default:
          throw `Unknown Kind ${kind}`;
      }
    },

    _mergeAggregates(aggregates) {
      let annotations = aggregates.annotation.buckets
          .map(val => {
            return {
              key: val.key,
              total: val.doc_count,
              buckets: val.series.buckets
            }
          })
          .reduce((map, val) => {
            map[val.key] = val;
            return map;
          }, {});

      if (Object.keys(annotations).length === 0) {
        return [];
      }

      // handle cases when some buckets are missing
      const confirmed = annotations[annotationValues.CONFIRMED];
      const rejected = annotations[annotationValues.REJECTED];
      let buckets = [];
      if (confirmed) {
        buckets = buckets.concat(confirmed.buckets);
      }
      if (rejected) {
        buckets = buckets.concat(rejected.buckets);
      }
      const yesNoBucketMap = buckets.reduce(function (map, obj) {
        let res = map[obj.key];
        if (res) {
          res.doc_count += obj.doc_count;
        } else {
          res = obj;
        }

        map[res.key] = res;
        return map;
      }, {});

      // handle cases when some buckets are missing
      const notSure = annotations[annotationValues.NOT_SURE];
      const handInput = annotations[annotationValues.HAND_INPUT];
      buckets = [];
      if (notSure) {
        buckets = buckets.concat(notSure.buckets);
      }
      if (handInput) {
        buckets = buckets.concat(handInput.buckets);
      }
      const timeSeries = Object.values(yesNoBucketMap)
          .concat(buckets)
          .map(val => val.key)
          .filter((v, i, a) => a.indexOf(v) === i)
          .sort((a, b) => a - b);

      // We need to define default key/total in case there is no bucket
      let key = 'confirmed';
      let total = 0;
      if (confirmed) {
        key = confirmed.key;
        total = confirmed.total;
      }
      if (rejected) {
        total = total + rejected.total;
      }
      let yesNo = {
        key: key,
        total: total,
        buckets: Object.values(yesNoBucketMap)
      }
      if (notSure) {
        annotations[annotationValues.NOT_SURE].buckets = this._fillBuckets(annotations[annotationValues.NOT_SURE].buckets, timeSeries);
      }
      if (handInput) {
        annotations[annotationValues.HAND_INPUT].buckets = this._fillBuckets(annotations[annotationValues.HAND_INPUT].buckets, timeSeries);
      }
      yesNo.buckets = this._fillBuckets(yesNo.buckets, timeSeries);
      let result = [];
      if (notSure) {
        result.push(notSure);
      }
      if (handInput) {
        result.push(handInput);
      }
      result.push(yesNo);
      return result;
    },

    _fillBuckets(original, idxs) {
      let result = original.reduce(function (map, obj) {
        let res = map[obj.key];
        if (res) {
          res.doc_count += obj.doc_count;
        } else {
          res = obj;
        }

        map[res.key] = res;
        return map;
      }, {});

      for (let ts of idxs) {
        if (!result[ts]) {
          result[ts] = {
            "key_as_string": new Date(ts).toISOString(),
            "key": ts,
            "doc_count": 0
          }
        }
      }

      return Object.values(result);
    },

    _labelFor(key) {
      switch (key) {
        case annotationValues.CONFIRMED:
        case annotationValues.REJECTED:
        case _YES_NO:
          return _YES_NO;
        case annotationValues.HAND_INPUT:
        case _INPUT:
          return _INPUT;
        default:
          return _NOT_SURE;
      }
    },

    _colorFor(key) {
      switch (key) {
        case annotationValues.CONFIRMED:
        case annotationValues.REJECTED:
        case _YES_NO:
          return Color.orange;
        case annotationValues.HAND_INPUT:
        case _INPUT:
          return Color.lightBlue;
        default:
          return Color.gray;
      }
    }
  }
}
